var _rect, _path, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCustomerValidatingActive(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 40,
    viewBox: "0 0 41 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.800049,
    width: 40,
    height: 40,
    rx: 20,
    fill: "#FDE0E0"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.05 28V17.3333L19.25 12L24.0875 15.6C23.7125 15.6444 23.36 15.7296 23.03 15.8556C22.7 15.9815 22.385 16.1481 22.085 16.3556L19.25 14.2222L13.85 18.2222V26.2222H17.45V28H12.05ZM19.25 28V26.3111C19.25 26 19.3288 25.7074 19.4863 25.4333C19.6438 25.1593 19.8575 24.9407 20.1275 24.7778C20.8175 24.3778 21.5413 24.0741 22.2988 23.8667C23.0563 23.6593 23.84 23.5556 24.65 23.5556C25.46 23.5556 26.2438 23.6593 27.0013 23.8667C27.7588 24.0741 28.4825 24.3778 29.1725 24.7778C29.4425 24.9407 29.6563 25.1593 29.8138 25.4333C29.9713 25.7074 30.05 26 30.05 26.3111V28H19.25ZM21.185 26.2222H28.115C27.59 25.9259 27.035 25.7037 26.45 25.5556C25.865 25.4074 25.265 25.3333 24.65 25.3333C24.035 25.3333 23.435 25.4074 22.85 25.5556C22.265 25.7037 21.71 25.9259 21.185 26.2222ZM24.65 22.6667C23.9 22.6667 23.2625 22.4074 22.7375 21.8889C22.2125 21.3704 21.95 20.7407 21.95 20C21.95 19.2593 22.2125 18.6296 22.7375 18.1111C23.2625 17.5926 23.9 17.3333 24.65 17.3333C25.4 17.3333 26.0375 17.5926 26.5625 18.1111C27.0875 18.6296 27.35 19.2593 27.35 20C27.35 20.7407 27.0875 21.3704 26.5625 21.8889C26.0375 22.4074 25.4 22.6667 24.65 22.6667ZM24.65 20.8889C24.905 20.8889 25.1188 20.8037 25.2913 20.6333C25.4638 20.463 25.55 20.2519 25.55 20C25.55 19.7481 25.4638 19.537 25.2913 19.3667C25.1188 19.1963 24.905 19.1111 24.65 19.1111C24.395 19.1111 24.1813 19.1963 24.0088 19.3667C23.8363 19.537 23.75 19.7481 23.75 20C23.75 20.2519 23.8363 20.463 24.0088 20.6333C24.1813 20.8037 24.395 20.8889 24.65 20.8889Z",
    fill: "url(#paint0_linear_496_229531)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_496_229531",
    x1: 12.05,
    y1: 12,
    x2: 30.356,
    y2: 12.358,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#004C3B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B4112E"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCustomerValidatingActive);
export default __webpack_public_path__ + "static/media/CustomerValidatingActive.4e1748daafcd5ca57deced9f8c1e72ed.svg";
export { ForwardRef as ReactComponent };